export default __webpack_public_path__ + "static/coll-immunity-fdbc206b7cabb0d30e90981fb8d21775.jpg";